import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import en from './locales/en.json';
import it from './locales/it.json';
import es from './locales/es.json';
import fr from './locales/fr.json';

i18n
    .use(LanguageDetector)
    .use(initReactI18next)
    .init({
        resources: {
            en: { translation: en },
            it: { translation: it },
            es: { translation: es },
            fr: { translation: fr }
        },
        fallbackLng: 'it',
        detection: {
            order: ['localStorage', 'navigator'],
            caches: ['localStorage']
        },
        interpolation: {
            escapeValue: false
        }
    });

// Funzione per caricare la lingua dal DB/impostazioni utente
export function loadUserLanguage(userLanguage: string): void {
    if (userLanguage) {
        i18n.changeLanguage(userLanguage);
    }
}

export default i18n;